import { baseApi } from "../../api/baseApi";

const contactApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    submitContactMessage: builder.mutation({
      query: (data) => ({
        url: "/webapp/contact/",
        method: "POST",
        body: data,
      }),
    }),
  }),
});

export const { useSubmitContactMessageMutation } = contactApi;
